var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { StringWidget as _StringWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var StringWidget = (function (_super) {
    __extends(StringWidget, _super);
    function StringWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StringWidget.prototype, "widget", {
        get: function () {
            var widget = this.schema.widget;
            return typeof widget === 'string' ? { id: widget } : widget;
        },
        enumerable: true,
        configurable: true
    });
    StringWidget.prototype.getInputType = function () {
        if (!this.widget.id || this.widget.id === 'string') {
            return 'text';
        }
        else {
            return this.widget.id;
        }
    };
    Object.defineProperty(StringWidget.prototype, "prefix", {
        get: function () {
            return (this.schema.options && this.schema.options.prefix) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StringWidget.prototype, "suffix", {
        get: function () {
            return (this.schema.options && this.schema.options.suffix) || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StringWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return StringWidget;
}(_StringWidget));
export { StringWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/string.widget.ts.pre-build-optimizer.js